import { LoanPeriod } from "../../../constants/Constants";
import { convertToDollar, convertToFloat } from "./SaleFunctions";
// Leasefunctions
//export const calculateResidualValue = (msrp, residualFactor, mileageCharge) => {
export const calculateResidualValue = (msrp, residualFactor) => {
	let ressValue = msrp * residualFactor;
	// if (ressValue - mileageCharge >= 0) {
	// 	console.log("ressValue - mileageCharge >= 0");
	// 	ressValue = msrp * residualFactor - mileageCharge;
	// }
	// console.log({ ressValue });
	return convertToDollar(ressValue);
};
export const calculateResidualFactor = (residualValue, msrp) => {
	if (residualValue === 0) return 0;
	return residualValue / msrp;
};

export const calculateDepreciation = (capCost, residualValue) => {
	return convertToDollar(capCost - residualValue);
};

export const calculateBasePayment = (depreciation, rentCharge) => {
	return convertToDollar(depreciation + rentCharge);
};

export const calculateMonthlyTax = (capSalesTax, basePayment, taxRate) => {
	if (capSalesTax) return convertToDollar(basePayment * taxRate, 2);
	else return 0;
};

export function aprFromMoneyFactor(moneyFactor, periodsPerYear = 12) {
	const mf = Number(moneyFactor) || 0;
	const p = Number(periodsPerYear) || 12;
	// Inverse of: MF = (APR% / 100) / (2 * p)
	// => APR% = MF * 2 * p * 100
	return mf * 2 * p * 100;
}
export function moneyFactorFromApr(aprPercent, periodsPerYear = 12) {
	console.log(aprPercent, periodsPerYear);
	const p = Number(periodsPerYear) || 12;
	const aprDec = Number(aprPercent) || 0;
	// MF = APR / (2 * periodsPerYear)
	return aprDec / (2 * p);
}
export function calculateCapCost(lease, sale) {
	let capCost =
		lease.price +
		sale.aftmkt +
		sale.collisionTotPremium +
		sale.payoff +
		lease.mileageCharge;
	if (lease.capDMVFee) capCost += sale.totalDMVFees;
	if (lease.capBankFee) capCost += lease.bankFee;
	if (lease.capGAPWaiver) capCost += lease.gapWaiver;
	if (lease.capWarranty) capCost += sale.warranty;
	if (lease.capDocFee) capCost += lease.docfee ?? 0;
	if (lease.capMiscFee) capCost += lease.miscFee;
	if (lease.capOtherfee) capCost += lease.otherFee;
	if (lease.capDispositionFee) capCost += lease.disposition;
	if (lease.capSmogFees)
		capCost += sale.dealerSmog + sale.stateSmog + sale.smogImpact;
	if (capCost < 0.01) capCost = 0;
	return capCost;
}
export function calculateTotalTax(monthlyTax, lease) {
	return monthlyTax * lease.term + lease.downTax;
}
export function calculateAdditionalTax(lease, sale, dealTaxSettings) {
	let additionalTax = 0;
	if (!lease.capGAPWaiver)
		additionalTax +=
			sale.gap *
			(dealTaxSettings.gapTaxRate !== -1
				? dealTaxSettings.gapTaxRate
				: sale.taxRate);
	if (!lease.capWarranty)
		additionalTax +=
			sale.warranty *
			(dealTaxSettings.servContractTaxRate !== -1
				? dealTaxSettings.servContractTaxRate
				: sale.taxRate);
	additionalTax +=
		sale.aftmkt *
		(dealTaxSettings.aftMktTaxRate !== -1
			? dealTaxSettings.aftMktTaxRate
			: sale.taxRate);
	if (!lease.capDocFee)
		additionalTax +=
			(lease.docfee ?? 0) *
			(dealTaxSettings.docFeeTaxRate !== -1
				? dealTaxSettings.docFeeTaxRate
				: sale.taxRate);
	if (!lease.capMiscFee) additionalTax += lease.miscFee * sale.taxRate;
	if (!lease.capOtherfee) additionalTax += lease.otherFee * sale.taxRate;
	// Disposition: 0=At Lease End (no tax now), 1=Drive-Off (add tax), 2=Capitalized (no tax here)
	if (lease.capDispositionFee === 1)
		additionalTax += lease.disposition * sale.taxRate;

	return additionalTax;
}
export function calculateMiscFee(deal) {
	let sum = 0.0;
	deal.miscSellerFees.forEach((key) => {
		if (key.isTaxable) {
			sum += key.amount;
		}
	});
	return sum;
}
export function calculateOtherFee(deal) {
	let nonTaxSum = 0.0;
	deal.miscSellerFees.forEach((key) => {
		if (!key.isTaxable) {
			nonTaxSum += key.amount;
		}
	});
	return nonTaxSum;
}
export function Days2PayInterest(d) {
	////	daysPerPeriod=	LoanPeriod[loanPeriod].daysInPeriod

	//   Dim rtn As Single
	//   Dim DailyInt As Double

	//   rtn = 0
	//   DailyInt = Lease.APR / 365

	//   if () d < daysPerPeriod() Then ' Credit
	//     rtn = -1 * (daysPerPeriod() - d) * DailyInt

	//   ElseIf d = daysPerPeriod() Then
	//     rtn = 0

	//   Else ' D > daysPerPeriod
	//     rtn = (d - daysPerPeriod()) * DailyInt

	//   End If

	return rtn;
}

// Lease Roll Functions - Using direct algebraic calculation (professional approach)

/**
 * Roll by Price - Direct algebraic calculation
 * Formula: monthlyPmt = [(netCap - residual)/term + (netCap + residual) * MF] * (1 + taxRate if capSalesTax)
 * netCap = grossCapCost - capReduction
 * grossCapCost = price + extras
 */
export const rollByLeasePrice = (
	desiredPmt,
	currentNetCap,
	currentGrossCapCost,
	currentPrice,
	term,
	leasePeriod,
	apr,
	residualValue,
	capReduction,
	capSalesTax,
	taxRate
) => {
	if (term === 0) return currentPrice;

	const periodsPerYear = LoanPeriod[leasePeriod].term || 12;
	const moneyFactor = moneyFactorFromApr(apr, periodsPerYear);

	// Adjust desired payment for tax
	const desiredBasePmt = capSalesTax ? desiredPmt / (1 + taxRate) : desiredPmt;

	// Solve for netCap
	// basePmt = (netCap - residual)/term + (netCap + residual) * MF
	// basePmt = netCap/term - residual/term + netCap*MF + residual*MF
	// basePmt = netCap * (1/term + MF) + residual * (MF - 1/term)
	// netCap = (basePmt - residual * (MF - 1/term)) / (1/term + MF)

	const netCapFactor = 1 / term + moneyFactor;
	const residualPart = residualValue * (moneyFactor - 1 / term);
	const newNetCap = (desiredBasePmt - residualPart) / netCapFactor;

	// grossCapCost = netCap + capReduction
	const newGrossCapCost = newNetCap + capReduction;

	// price = grossCapCost - extras
	// extras = currentGrossCapCost - currentPrice
	const extras = currentGrossCapCost - currentPrice;
	const newPrice = newGrossCapCost - extras;

	return convertToDollar(newPrice);
};

/**
 * Roll by Down/Cap Reduction - Direct algebraic calculation
 */
export const rollByLeaseDown = (
	desiredPmt,
	currentNetCap,
	currentGrossCapCost,
	currentCapReduction,
	term,
	leasePeriod,
	apr,
	residualValue,
	capSalesTax,
	taxRate
) => {
	if (term === 0) return currentCapReduction;

	const periodsPerYear = LoanPeriod[leasePeriod].term || 12;
	const moneyFactor = moneyFactorFromApr(apr, periodsPerYear);

	// Adjust desired payment for tax
	const desiredBasePmt = capSalesTax ? desiredPmt / (1 + taxRate) : desiredPmt;

	// Solve for netCap (same formula as rollByPrice)
	const netCapFactor = 1 / term + moneyFactor;
	const residualPart = residualValue * (moneyFactor - 1 / term);
	const newNetCap = (desiredBasePmt - residualPart) / netCapFactor;

	// capReduction = grossCapCost - netCap
	// Since grossCapCost doesn't change (price and extras stay the same)
	const newCapReduction = currentGrossCapCost - newNetCap;

	return newCapReduction > 0 ? convertToDollar(newCapReduction) : 0;
};

/**
 * Roll by APR - Direct algebraic calculation
 */
export const rollByLeaseApr = (
	desiredPmt,
	netCap,
	term,
	leasePeriod,
	residualValue,
	capSalesTax,
	taxRate
) => {
	if (term === 0) return 0;

	// Adjust desired payment for tax
	const desiredBasePmt = capSalesTax ? desiredPmt / (1 + taxRate) : desiredPmt;

	// basePmt = (netCap - residual)/term + (netCap + residual) * MF
	// basePmt = depreciation/term + (netCap + residual) * MF
	const depreciation = netCap - residualValue;
	const depreciationPmt = depreciation / term;

	// rentCharge = basePmt - depreciationPmt
	const rentCharge = desiredBasePmt - depreciationPmt;

	// rentCharge = (netCap + residual) * MF
	// MF = rentCharge / (netCap + residual)
	const moneyFactor = rentCharge / (netCap + residualValue);

	// APR = MF * 2 * periodsPerYear * 100
	const periodsPerYear = LoanPeriod[leasePeriod].term || 12;
	const newApr = aprFromMoneyFactor(moneyFactor, periodsPerYear) / 100;

	return newApr > 0 ? Number(newApr.toFixed(8)) : 0;
};

/**
 * Roll by Term - Direct algebraic calculation
 */
export const rollByLeaseTerm = (
	desiredPmt,
	netCap,
	leasePeriod,
	apr,
	residualValue,
	capSalesTax,
	taxRate
) => {
	const periodsPerYear = LoanPeriod[leasePeriod].term || 12;
	const moneyFactor = moneyFactorFromApr(apr, periodsPerYear);

	// Adjust desired payment for tax
	const desiredBasePmt = capSalesTax ? desiredPmt / (1 + taxRate) : desiredPmt;

	// basePmt = (netCap - residual)/term + (netCap + residual) * MF
	// basePmt = depreciation/term + rentCharge
	const depreciation = netCap - residualValue;
	const rentCharge = (netCap + residualValue) * moneyFactor;

	// basePmt - rentCharge = depreciation/term
	// term = depreciation / (basePmt - rentCharge)
	const availableForDepreciation = desiredBasePmt - rentCharge;
	if (availableForDepreciation <= 0) return 1;

	const newTerm = Math.round(depreciation / availableForDepreciation);

	return newTerm > 0 ? newTerm : 1;
};

/**
 * Roll by Markup - For RTO only
 * Adjusts markup to achieve desired payment
 * Similar to rollByPrice but solves for markup instead
 */
export const rollByMarkup = (
	desiredPmt,
	currentNetCap,
	currentGrossCapCost,
	currentMarkup,
	totalCost,
	term,
	leasePeriod,
	apr,
	residualValue,
	capReduction,
	capSalesTax,
	taxRate
) => {
	if (term === 0 || totalCost === 0) return currentMarkup;

	const periodsPerYear = LoanPeriod[leasePeriod].term || 12;
	const moneyFactor = moneyFactorFromApr(apr, periodsPerYear);

	// Adjust desired payment for tax
	const desiredBasePmt = capSalesTax ? desiredPmt / (1 + taxRate) : desiredPmt;

	// Solve for netCap first (same as rollByPrice)
	const netCapFactor = 1 / term + moneyFactor;
	const residualPart = residualValue * (moneyFactor - 1 / term);
	const newNetCap = (desiredBasePmt - residualPart) / netCapFactor;

	// grossCapCost = netCap + capReduction
	const newGrossCapCost = newNetCap + capReduction;

	// For RTO: price = totalCost + markup
	// extras = currentGrossCapCost - currentPrice
	// currentPrice = totalCost + currentMarkup
	const currentPrice = totalCost + currentMarkup;
	const extras = currentGrossCapCost - currentPrice;

	// newPrice = newGrossCapCost - extras
	const newPrice = newGrossCapCost - extras;

	// newMarkup = newPrice - totalCost
	const newMarkup = newPrice - totalCost;

	return convertToDollar(newMarkup);
};

/**
 * Roll by Residual - Direct algebraic calculation
 * @param {number} baseValue - For Lease: msrp, For RTO: price
 */
export const rollByLeaseResidual = (
	desiredPmt,
	netCap,
	term,
	leasePeriod,
	apr,
	capSalesTax,
	taxRate,
	baseValue
) => {
	if (term === 0) return 0;

	const periodsPerYear = LoanPeriod[leasePeriod].term || 12;
	const moneyFactor = moneyFactorFromApr(apr, periodsPerYear);

	// Adjust desired payment for tax
	const desiredBasePmt = capSalesTax ? desiredPmt / (1 + taxRate) : desiredPmt;

	// basePmt = (netCap - residual)/term + (netCap + residual) * MF
	// basePmt = netCap/term - residual/term + netCap*MF + residual*MF
	// basePmt = netCap * (1/term + MF) + residual * (MF - 1/term)
	// residual = (basePmt - netCap * (1/term + MF)) / (MF - 1/term)

	const netCapPart = netCap * (1 / term + moneyFactor);
	const residualFactor = moneyFactor - 1 / term;

	if (residualFactor === 0) return 0;

	const newResidual = (desiredBasePmt - netCapPart) / residualFactor;
	calculateResidualFactor(newResidual, baseValue);
	return newResidual > 0 ? convertToDollar(newResidual) : 0;
};

/**
 * Roll by DriveOff - Direct algebraic calculation
 * Adjusts down payment to achieve desired drive-off amount
 *
 * DriveOff formula:
 * driveOff = down + securityDeposit + gpsService + aftmkt + [uncapped fees] + [firstPmt if !capFirstPmt] + tax
 *
 * When capSalesTax=true: downTax = (capReduction - tradeTaxCredit) * taxRate + deferredTax
 * capReduction = lsRebate + down + totalNetTrade + totalPickupPmts
 *
 * So: driveOff = down*(1 + taxRate) + otherComponents + otherCapReductionComponents*taxRate - tradeTaxCredit*taxRate + deferredTax
 * Solving: down = (desiredDriveOff - otherComponents - otherCapReductionComponents*taxRate + tradeTaxCredit*taxRate - deferredTax) / (1 + taxRate)
 */
export const rollByLeaseDriveOff = (
	desiredDriveOff,
	currentDown,
	monthlyPmt,
	lease,
	sale,
	totalDMVFees,
	warranty,
	miscFee,
	otherFee,
	aftmkt,
	additionalTax,
	totalTax,
	cancellationAmt,
	cancellationAccepted,
	lsRebate,
	totalNetTrade,
	totalPickupPmts,
	tradeTaxCredit,
	deferredTax
) => {
	// Calculate components that don't change with down payment
	let otherComponents = lease.securityDeposit + lease.gpsService + aftmkt;

	// Add uncapped fees
	if (!lease.capDMVFee) otherComponents += totalDMVFees;
	if (!lease.capBankFee) otherComponents += lease.bankFee;
	if (!lease.capGAPWaiver) otherComponents += lease.gapWaiver;
	if (!lease.capWarranty) otherComponents += warranty;
	if (!lease.capDocFee) otherComponents += lease.docfee ?? 0;
	if (!lease.capMiscFee) otherComponents += miscFee;
	if (!lease.capOtherfee) otherComponents += otherFee;
	if (!lease.capDispositionFee) otherComponents += lease.disposition;
	if (!lease.capFirstPmt) otherComponents += monthlyPmt;
	if (cancellationAccepted === 1)
		otherComponents += parseFloat(cancellationAmt) || 0;

	let newDown;

	if (lease.capSalesTax) {
		// When sales tax is capitalized, downTax depends on down payment
		// driveOff = down + otherComponents + additionalTax + downTax
		// downTax = (capReduction - tradeTaxCredit) * taxRate + deferredTax
		// capReduction = lsRebate + down + totalNetTrade + totalPickupPmts

		const otherCapReductionComponents =
			lsRebate + totalNetTrade + totalPickupPmts;

		// Solve: down = (desiredDriveOff - otherComponents - additionalTax - otherCapReductionComponents*taxRate + tradeTaxCredit*taxRate - deferredTax) / (1 + taxRate)
		newDown =
			(desiredDriveOff -
				otherComponents -
				additionalTax -
				otherCapReductionComponents * sale.taxRate +
				tradeTaxCredit * sale.taxRate -
				deferredTax) /
			(1 + sale.taxRate);
	} else {
		// When sales tax is not capitalized, tax doesn't depend on down payment
		// driveOff = down + otherComponents + totalTax
		newDown = desiredDriveOff - otherComponents - totalTax;
	}

	return newDown > 0 ? convertToDollar(newDown) : 0;
};

// ==================== RTO ROLL FUNCTIONS (Rent-to-Own - No Money Factor) ====================
/**
 * RTO uses simple depreciation formula with NO interest/money factor:
 * payment = (depreciation / term) + tax
 * depreciation = netCap - residual
 *
 * These are completely separate from Lease roll functions above
 */

/**
 * Roll by Price - RTO Version (No Money Factor)
 */
export const rollByRTOPrice = (
	desiredPmt,
	currentNetCap,
	currentGrossCapCost,
	currentPrice,
	term,
	residualValue,
	capReduction,
	capSalesTax,
	taxRate
) => {
	if (term === 0) return currentPrice;

	// Adjust desired payment for tax
	const desiredBasePmt = capSalesTax ? desiredPmt / (1 + taxRate) : desiredPmt;

	// RTO: basePmt = (netCap - residual) / term
	// Solve for netCap: netCap = basePmt * term + residual
	const newNetCap = desiredBasePmt * term + residualValue;

	// grossCapCost = netCap + capReduction
	const newGrossCapCost = newNetCap + capReduction;

	// price = grossCapCost - extras
	const extras = currentGrossCapCost - currentPrice;
	const newPrice = newGrossCapCost - extras;

	return convertToDollar(newPrice);
};

/**
 * Roll by Down/Reduction - RTO Version (No Money Factor)
 */
export const rollByRTODown = (
	desiredPmt,
	currentNetCap,
	currentGrossCapCost,
	currentCapReduction,
	term,
	residualValue,
	capSalesTax,
	taxRate
) => {
	if (term === 0) return currentCapReduction;

	// Adjust desired payment for tax
	const desiredBasePmt = capSalesTax ? desiredPmt / (1 + taxRate) : desiredPmt;

	// RTO: netCap = basePmt * term + residual
	const newNetCap = desiredBasePmt * term + residualValue;

	// capReduction = grossCapCost - netCap
	const newCapReduction = currentGrossCapCost - newNetCap;

	return newCapReduction > 0 ? convertToDollar(newCapReduction) : 0;
};

/**
 * Roll by Term - RTO Version (No Money Factor)
 */
export const rollByRTOTerm = (
	desiredPmt,
	netCap,
	residualValue,
	capSalesTax,
	taxRate
) => {
	// Adjust desired payment for tax
	const desiredBasePmt = capSalesTax ? desiredPmt / (1 + taxRate) : desiredPmt;

	// RTO: basePmt = depreciation / term
	// Solve for term: term = depreciation / basePmt
	const depreciation = netCap - residualValue;

	if (desiredBasePmt <= 0) return 1;

	const newTerm = Math.round(depreciation / desiredBasePmt);

	return newTerm > 0 ? newTerm : 1;
};

/**
 * Roll by Residual - RTO Version (No Money Factor)
 */
export const rollByRTOResidual = (
	desiredPmt,
	netCap,
	term,
	capSalesTax,
	taxRate
) => {
	if (term === 0) return 0;

	// Adjust desired payment for tax
	const desiredBasePmt = capSalesTax ? desiredPmt / (1 + taxRate) : desiredPmt;

	// RTO: basePmt = (netCap - residual) / term
	// Solve for residual: residual = netCap - (basePmt * term)
	const newResidual = netCap - desiredBasePmt * term;

	return newResidual > 0 ? convertToDollar(newResidual) : 0;
};
